module.exports = __webpack_public_path__ + "static/img/jeans.c7caa7f1.webp";